import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {closeContactPopup, sendContactPopup} from "../../actionCreators";
import Recaptcha from 'react-recaptcha';

const captchaKey = window.getConfig.siteKey;

class PopupContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmittedForm: false,
      form: {
        name: null,
        surname: null,
        email: null,
        telephone: null,
        message: null,
        token: null
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {errorsContactUs, success} = this.props;
    const {handleClosePopup} = this;
    if((errorsContactUs && errorsContactUs.length === 0) || success) {
      handleClosePopup();
    }
  }

  handleClosePopup = () => {
    const {closeContactPopup} = this.props;

    closeContactPopup();
    this.setState({
      isSubmittedForm: false,
      form: {
        name: null,
        surname: null,
        email: null,
        telephone: null,
        message: null,
        token: null
      }
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      form: {
        ...this.state.form,
        [name]: value
      }
    });
  }

  verifyCallback = (response) => {
    this.setState({
      form: {
        ...this.state.form,
        token: response
      }
    })
  }

  recaptchaLoaded = () => {
    console.log('recaptchaLoaded');
  }

  sendForm = (e) => {
    const {sendContactPopup} = this.props;
    const {form} = this.state;
    const {validateEmail, handleClosePopup} = this;
    this.setState({
      isSubmittedForm: true
    });
    if(form.name && form.surname && validateEmail(form.email) && form.telephone && form.message && form.token) {
      sendContactPopup(this.state.form);
      handleClosePopup();
    }
  };

  validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  render() {
    const {isShowContactPopup, errorsContactUs} = this.props;
    const {form, isSubmittedForm} = this.state;
    const {handleClosePopup, handleSubmit, sendForm, handleInputChange, validateEmail} = this;
    const listErrorsContactUs = errorsContactUs && errorsContactUs.length !==0 ? errorsContactUs.map((item) => <li key={item.message}>{item.field === 'token' ? 'Select captcha.' : item.message + ' '}</li>) : '';
    return (
      <Fragment>
        {isShowContactPopup ? (
          <Fragment>
            <div className="form__overlay" onClick={handleClosePopup} />
            <div className="form form--js">
              <div className="form__wrap">
                <form onSubmit={handleSubmit} method="POST" action="true">
                  <div className="form__inner">
                    <button className="form__close" type="button" onClick={handleClosePopup} />
                    <h3>Bitte füllen Sie das folgende Formular aus</h3>
                    <div className="form__body">
                      <div className="form__row">
                        <div className={"form__input form__input--common " + (!form.name && isSubmittedForm ? 'form__error' : '')}>
                          <input name="name" type="text" id="form-name" onChange={handleInputChange} defaultValue={form.name} required />
                          <label htmlFor="form-name">Vorname</label>
                        </div>
                        <div className={"form__input form__input--common " + (!form.surname && isSubmittedForm ? 'form__error' : '')}>
                          <input name="surname" type="text" id="form-surname" onChange={handleInputChange} defaultValue={form.surname} required />
                          <label htmlFor="form-surname">Nachname</label>
                        </div>
                      </div>
                      <div className="form__row">
                        <div className={"form__input form__input--common " + (!validateEmail(form.email) && isSubmittedForm ? 'form__error' : '')}>
                          <input name="email" type="text" id="form-email" onChange={handleInputChange} defaultValue={form.email} required />
                          <label htmlFor="form-email">Email</label>
                        </div>
                        <div className={"form__input form__input--common " + (!form.telephone && isSubmittedForm ? 'form__error' : '')}>
                          <input name="telephone" type="tel" id="form-telephone" onChange={handleInputChange} defaultValue={form.telephone} required />
                          <label htmlFor="form-telephone">Telefon</label>
                        </div>
                      </div>
                      <div className="form__row">
                        <div className="form__left">
                          <div className={"form__textarea form__input--common " + (!form.message && isSubmittedForm ? 'form__error' : '')}>
                            <textarea name="message" id="form-message" onChange={handleInputChange} defaultValue={form.message} required />
                            <label htmlFor="form-message">Anliegen</label>
                          </div>
                        </div>
                        <div className="form__right">
                          <div className={"form-error-captcha " + (!form.token && isSubmittedForm ? 'form__error--captcha' : '')}>
                            <Recaptcha
                              elementID={'g-recaptcha-1'}
                              sitekey={captchaKey}
                              render="explicit"
                              verifyCallback={this.verifyCallback}
                              onloadCallback={this.recaptchaLoaded}
                              hl={"de"}
                            />
                          </div>
                          {!form.token && isSubmittedForm ? (<div className="form__error">Fill captcha</div>) : ('')}
                        </div>
                      </div>
                      <ul className="form-error__list">{ errorsContactUs && errorsContactUs.length !==0 ? listErrorsContactUs : ('') }</ul>
                      <div className="form__btn">
                        <button onClick={sendForm}>senden</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Fragment>
        ) : ( '' )}
      </Fragment>
    );
  }
}


export default connect((state) => {
  return {
    success: state.contactus.success,
    errorsContactUs: state.contactus.errorsFields,
    isShowContactPopup: state.contactus.isShowContactPopup
  }
}, {closeContactPopup, sendContactPopup})(PopupContact);


// WEBPACK FOOTER //
// ./src/components/Popups/PopupContact.js